var _style, _path, _path2, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectromagneticActuator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,14.6v-3.4C5.2,11.2,6.7,9.8,6.8,8C6.7,6.2,5.2,4.8,3.4,4.9V0.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,4.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.4,
    y1: 11.1,
    x2: 3.4,
    y2: 15.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.8,
    y1: 8,
    x2: 7.6,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.5,
    y1: 8,
    x2: 9.3,
    y2: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.2,
    y1: 8,
    x2: 11,
    y2: 8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.9,
    y1: 8,
    x2: 12.8,
    y2: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectromagneticActuator);
export default __webpack_public_path__ + "static/media/ElectromagneticActuator.45eb09e040fa1ef0e3a63138134bd6c7.svg";
export { ForwardRef as ReactComponent };